const styles = theme => ({
    wrapper: {
        position: 'relative',
        margin: theme.spacing(1),
        width: 'fit-content'
    },
    progress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },
});

export default styles;